import { gql, QueryHookOptions, useQuery } from '@provision/graphql-client';
import { useMemo } from 'react';
import { Records } from 'src/graphql/types';

const GET_CONVERSATION_CHANNEL_TYPE_QUERY = gql`
  query GetConversationChannelType @entity(name: "ConversationChannelType") {
    getConversationChannelType {
      records {
        id
        conversationChannelTypeId
        title
      }
    }
  }
`;

interface GetConversationChannelTypeQuery {
  getConversationChannelType: Records<{
    id: string;
    conversationChannelTypeId: string;
    title: string;
  }>;
}

export const useConversationChannelTypes = (
  options?: QueryHookOptions<GetConversationChannelTypeQuery>,
) => {
  const { data, loading } = useQuery<GetConversationChannelTypeQuery>(
    GET_CONVERSATION_CHANNEL_TYPE_QUERY,
    {
      onError: console.error,
      ...options,
    },
  );

  const conversationChannelTypes = useMemo(() => {
    if (!data?.getConversationChannelType.records?.length) {
      return null;
    }

    return data?.getConversationChannelType.records;
  }, [data?.getConversationChannelType]);

  return {
    conversationChannelTypes,
    loading,
  };
};

export const useConversationChannelTypeOptions = (
  options?: QueryHookOptions<GetConversationChannelTypeQuery>,
) => {
  const { conversationChannelTypes } = useConversationChannelTypes(options);

  return useMemo(() => {
    if (!conversationChannelTypes) {
      return [];
    }

    return conversationChannelTypes.map((conversationChannelType) => ({
      id: conversationChannelType.conversationChannelTypeId,
      value: conversationChannelType.conversationChannelTypeId,
      label: conversationChannelType.title,
    }));
  }, [conversationChannelTypes]);
};
